<template>
  <div class="add_project">
    <div class="form_box">
      <el-form ref="form" :rules="rules" :model="form" label-width="90px">
        <!-- 头部公司信息 -->
        <div class="corporate_information">
          <!-- 左侧logo -->
          <div class="logo">
            <upload-image :imageUrls.sync="form.companyLogo" />
            <el-button v-if="form.companyLogo" @click="deleteImg" style="margin-top: 10px"
              >删除图片</el-button
            >
          </div>

          <!-- 右侧公司信息 -->
          <div class="details">
            <!-- 第一行 -->
            <div class="name_industry">
              <el-form-item class="flex_item" label="企业名称:" prop="corporateName">
                <el-autocomplete
                  class="inline-input"
                  v-model="form.corporateName"
                  :fetch-suggestions="enterpriseNameQuerySearch"
                  placeholder="请输入"
                  :trigger-on-focus="false"
                  @select="enterpriseNameSelect"
                  @input="inputChanged"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item class="flex_item" label="企业简称:" prop="companyName">
                <el-input v-model="form.companyName"></el-input>
              </el-form-item>
              <el-form-item class="flex_text" label="备注:">
                <el-input placeholder="请输入备注" v-model="form.remark"></el-input>
              </el-form-item>
              <!-- <div class="flex_text">备注：</div> -->
            </div>
            <!-- 第二行 -->
            <div class="address_contact">
              <el-form-item class="flex_item" label="所属行业:">
                <el-select v-model="form.industry" placeholder="请选择所属行业">
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in industryInvolvedList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="flex_item" label="总部地址:">
                <div class="distpicker_one">
                  <v-distpicker
                    @selected="onContactSelected"
                    :province="form.companyProvince"
                    :city="form.companyCity"
                    :area="form.companyDistrict"
                  ></v-distpicker>
                </div>
              </el-form-item>
            </div>
            <!-- 公司简介 -->
            <div class="company_profile">
              <el-form-item label="公司简介:">
                <el-input
                  v-model="form.companyProfile"
                  type="textarea"
                  resize="none"
                  :rows="4"
                ></el-input>
              </el-form-item>
            </div>

            <!-- add 主要联系人  岗位  联系方式 -->
            <!-- <div class="contacts">
              <el-form-item label="企业联系人:">
                <div class="contact_list" v-for="(item, index) in form.contactsList" :key="index">
                  <div class="contact_list_item">
                    <el-input
                      style="margin-right: 8px; width: 168px"
                      v-model="item.contacts"
                      placeholder="姓名"
                    ></el-input>
                    <el-input
                      style="margin-right: 8px; width: 168px"
                      v-model="item.post"
                      placeholder="岗位"
                    >
                    </el-input>
                    <el-input
                      style="margin-right: 8px; width: 168px"
                      v-model="item.phone"
                      placeholder="联系方式"
                    ></el-input>
                    <div class="add" @click="clickAddContact" v-if="index < 1">
                      <i class="add_icon el-icon-circle-plus-outline"></i>添加
                    </div>
                    <div v-if="index >= 1" @click="clickRemoveContact(item, index)" class="remove">
                      <i class="remove_icon el-icon-delete"></i>删除
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div> -->
          </div>
        </div>
        <!-- 职位信息 -->
        <div class="post_details">
          <!-- 头部标题 职位信息 -->
          <div class="post_details_heading">
            <div class="line"></div>
            <div class="text">职位信息</div>
          </div>
          <!-- 招聘职位  薪资范围 -->
          <div class="post_pay">
            <div class="post">
              <el-form-item
                label="招聘职位:"
                prop="recruitmentPosition"
                class="recruitmentPosition"
              >
                <!-- <el-input v-model="form.recruitmentPosition"></el-input> -->
                <el-autocomplete
                  class="inline-input"
                  v-model="form.recruitmentPosition"
                  :fetch-suggestions="positionListQuerySearch"
                  placeholder="请选择"
                  @select="positionSelect"
                  @input="inputChanged"
                ></el-autocomplete>
              </el-form-item>
            </div>
            <div class="pay">
              <el-form-item label="薪资范围:" class="pay">
                <!-- 月薪或者年薪0->月薪；1->年薪 -->
                <el-select v-model="form.isAnnual" class="is_annual" placeholder="年薪">
                  <el-option label="月薪" :value="0"> </el-option>
                  <el-option label="年薪" :value="1"> </el-option>
                </el-select>
                <el-input class="wages" v-model="form.wages"></el-input>
                <div style="color: #c4c4c4; margin: 0 4px">~</div>
                <el-input class="wagess" v-model="form.wagess"></el-input>
              </el-form-item>
            </div>
          </div>
          <!-- 职位类型  工作地点 -->
          <div class="positionType_place">
            <div class="positionType">
              <el-form-item label="职位类型:">
                <el-select v-model="form.positionType">
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in positionTypeList"
                    :key="index"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="place">
              <el-form-item label="工作地点:" prop="area">
                <div class="distpicker">
                  <v-distpicker
                    @selected="onSelected"
                    :province="form.province"
                    :city="form.city"
                    :area="form.area"
                  ></v-distpicker>
                </div>
                <div class="input">
                  <el-input
                    class="dutyStation"
                    v-model="form.dutyStation"
                    placeholder="请输入详细地址"
                  ></el-input>
                </div>
              </el-form-item>
            </div>
          </div>
          <!-- 汇报对象 -->
          <div class="report_object">
            <!-- <div></div> -->
            <div class="report">
              <el-form-item label="汇报对象:" prop="reportingObject">
                <el-input class="reportingObject" v-model="form.reportingObject"></el-input>
              </el-form-item>
            </div>
          </div>
          <!-- 职位描述 -->
          <div class="jobDescription">
            <div class="jobDescription_title"><span style="color: #f56c6c">*</span> 职位描述：</div>
            <el-form-item class="jobDescription_form_item" prop="jobDescription">
              <el-input
                class="flex_textarea"
                v-model="form.jobDescription"
                type="textarea"
                resize="none"
                :autosize="{ minRows: 4, maxRows: 8 }"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 所需技能 -->
          <div class="requiredSkills">
            <div class="requiredSkills_title"><span style="color: #f56c6c">*</span> 所需技能：</div>
            <el-form-item class="requiredSkills_form_item" prop="requiredSkills">
              <el-input
                class="flex_textarea"
                v-model="form.requiredSkills"
                type="textarea"
                resize="none"
                :autosize="{ minRows: 4, maxRows: 8 }"
              ></el-input>
            </el-form-item>
          </div>
          <!-- 核心要求 -->
          <div class="coreRequirements">
            <div class="coreRequirements_title">
              <!-- <span style="color: #f56c6c">*</span>  -->
              核心要求：
            </div>
            <el-form-item class="coreRequirements_form_item" prop="coreRequirements">
              <el-input
                class="flex_textarea"
                v-model="form.coreRequirements"
                type="textarea"
                resize="none"
                :autosize="{ minRows: 4, maxRows: 8 }"
              ></el-input>
            </el-form-item>
          </div>
          <!-- add 项目经理  联系方式  邮箱  目标企业 -->
          <div class="projectManagers">
            <div
              class="projectManagers_item"
              v-for="(item, index) in form.projectManagers"
              :key="index"
            >
              <!-- 项目经理 -->
              <div class="projectManager">
                <el-form-item
                  label="项目经理:"
                  :rules="rules.projectManager"
                  :prop="'projectManagers.' + index + '.projectManager'"
                >
                  <el-select
                    @change="
                      (value) => {
                        selectChange(value, item, index)
                      }
                    "
                    v-model="item.projectManager"
                    placeholder="请选择项目经理"
                  >
                    <el-option
                      v-for="(it, index) in ProjectManagerList"
                      :key="index"
                      :label="it"
                      :value="it"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <!-- 联系方式 -->
              <div class="contactWay">
                <el-form-item label="联系方式:">
                  <!--  :rules="rules.contactWay"  :prop="'projectManagers.' + index + '.contactWay'" -->
                  <el-input
                    readonly
                    placeholder="请输入联系方式"
                    v-model="item.contactWay"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 邮箱 -->
              <div class="mail">
                <el-form-item label="邮箱:">
                  <!-- :rules="rules.mail"    :prop="'projectManagers.' + index + '.mail'" -->
                  <el-input readonly placeholder="请输入邮箱" v-model="item.mail"></el-input>
                </el-form-item>
              </div>
              <!-- 目标企业 -->
              <!-- <div class="targetEnterprise">
                <el-form-item label="目标企业:">
                  <el-input placeholder="请输入目标企业" v-model="item.targetEnterprise"></el-input>
                </el-form-item>
              </div> -->

              <!-- 添加 -->
              <div class="add" @click="clickAddProjectManagers" v-if="index < 1">
                <i class="add_icon el-icon-circle-plus-outline"></i>添加
              </div>
              <div
                v-if="index >= 1"
                @click="clickRemoveProjectManagers(item, index)"
                class="remove"
              >
                <i class="remove_icon el-icon-delete"></i>删除
              </div>
            </div>
          </div>

          <!-- 客户反馈 -->
          <div class="marketFeedback">
            <div class="marketFeedback_title">客户反馈：</div>
            <el-form-item class="marketFeedback_form_item">
              <el-input
                class="flex_textarea"
                v-model="form.projectEvaluation"
                type="textarea"
                resize="none"
                :autosize="{ minRows: 4, maxRows: 8 }"
              ></el-input>
            </el-form-item>
          </div>

          <!-- 市场反馈 -->
          <div class="marketFeedback">
            <div class="marketFeedback_title">市场反馈：</div>
            <el-form-item class="marketFeedback_form_item">
              <el-input
                class="flex_textarea"
                v-model="form.marketFeedback"
                type="textarea"
                resize="none"
                :autosize="{ minRows: 4, maxRows: 8 }"
              ></el-input>
            </el-form-item>
          </div>

          <!-- 时间 -->
          <div class="startTime_endTime">
            <div class="startTime">
              <el-form-item label="启动时间:">
                <el-date-picker
                  v-model="form.startTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="请选择启动时间"
                >
                </el-date-picker>
              </el-form-item>
            </div>

            <div class="endTime">
              <el-form-item label="结束时间:">
                <el-date-picker
                  v-model="form.endTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  placeholder="请选择结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </div>

            <div>
              <el-form-item label="预计首推：">
                <el-input v-model="form.predictPush"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <!-- 底部操作按钮 -->
      <div class="options">
        <div class="keep" @click="clickKeep">保存</div>
        <div class="back" @click="clickBack">返回上级</div>
        <div class="deriveJD" @click="clickDeriveJD">导出JD</div>
      </div>
    </div>
  </div>
</template>
<script>
import UploadImage from '@/components/UploadImage.vue'
import {
  selectProjectBYId,
  getProjectManager,
  updateProject,
  projectCenterReportDownLoad,
  getCompanyNameList
} from '@/api/projectCenter.js'
import { userListAll } from '@/api/user'
import { selectPosition, getpositionListByid } from '@/api/position.js'
export default {
  components: { UploadImage },
  data() {
    return {
      currentJobTitle: '', // 选中的职位名称 区分是否为新增职位
      currentErpriseName: '', //当前选中的公司名称  区分是否为新增企业
      positionId: '', // 获取职位id
      companyCode: '', // 获取企业编号
      // 查询数据
      form: {
        area: '', //工作地区
        city: '', //工作城市
        province: '', //工作省份
        companyCity: '', // 所属城市
        companyCountry: '', // 所属国家
        companyLogo: '', // 公司logo
        companyLogoKey: '', //
        companyProfile: '', // 公司简介
        companyProvince: '', // 所属省份
        //联系人列表
        // contactsList: [
        //   {
        //     contacts: '',
        //     phone: '',
        //     post: ''
        //   }
        // ],
        coreRequirements: '', // 核心要求
        corporateName: '', // 公司名称
        createName: '', // 创建人名字
        createTime: '', // 创建时间
        dutyStation: '', // 工作地点
        endTime: '', // 结束时间
        id: '', // 主键
        industry: '', // 所属行业
        industrys: [], //
        isAnnual: '', // 月薪或者年薪0->月薪；1->年薪
        itemNo: '', //
        jobDescription: '', //  职位描述
        marketFeedback: '', //  市场反馈
        positionType: '', // 职位类型
        projectEvaluation: '', //  优先级别
        priority: '', //  项目评估
        // 项目经理信息集合
        projectManagers: [
          {
            contactWay: '', // 联系方式
            mail: '', // 邮箱
            projectManager: '' // 项目经理
            // targetEnterprise: '' // 目标企业
          }
        ],
        recruitmentPosition: '', //  招聘职位
        reportingObject: '', // 汇报对象
        requiredSkills: '', // 所需技能
        salaryRange: '', // 薪资范围
        startTime: '', // 启动时间
        updateName: '', // 修改人名字
        updateTime: '', // 修改时间
        wages: '', // 工资
        wagess: '', // 工资2
        predictPush: '', //  预计首推
        remark: '' // 备注
      },
      // 正则校验
      rules: {
        corporateName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        recruitmentPosition: [{ required: true, message: '请输入招聘职位', trigger: 'blur' }],
        area: [{ required: true, message: '请选择工作地点', trigger: 'blur' }],
        dutyStation: [{ required: true, message: '请输入工作详细地址', trigger: 'blur' }],
        jobDescription: [{ required: true, message: '请填写职位描述', trigger: 'blur' }],
        requiredSkills: [{ required: true, message: '请填写所需技能', trigger: 'blur' }],
        // coreRequirements: [{ required: true, message: '请填写核心要求', trigger: 'blur' }],
        projectManager: [{ required: true, message: '请输入项目经理', trigger: 'blur' }],
        contactWay: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        mail: [{ required: true, message: '请输入邮箱', trigger: 'blur' }]
      },
      // 所属行业数据 (目前是自己定义的)
      industryInvolvedList: [
        '不限',
        '大数据',
        '信息安全',
        '软件',
        '物联网',
        '云服务',
        '人工智能',
        '通信技术',
        'VR/AR',
        '区块链',
        '遥感卫星'
      ],
      // 定时器
      time: null,
      // 职位类型 (目前是定死的)
      positionTypeList: [
        '不限',
        '软件开发',
        '集成电路设计',
        '信息系统集成',
        '物联网技术服务',
        '运行维护服务',
        '信息处理和存储支持服务',
        '信息技术咨询服务',
        '数字内容服务',
        '解决方案咨询服务',
        '其他信息技术服务',
        '互联网接入及相关服务',
        '互联网信息服务',
        '互联网平台',
        '互联网安全服务',
        '互联网数据服务',
        '其他互联网服务',
        '计算机(通信及其他电子设备)制造业',
        '专用设备制造业',
        '其他制造业'
      ],
      // 获取项目经理
      ProjectManagerList: [],
      enterpriseNameList: [], //查询到的企业名称列表
      positionList: [] //查询到的职位名称
    }
  },
  computed: {
    id() {
      return this.$route.query.id ? this.$route.query.id : ''
    },
    Authorization() {
      return sessionStorage.getItem('token')
    }
  },
  watch: {},
  methods: {
    // 查找数据
    async search() {
      const { data: res } = await selectProjectBYId({ id: this.id })
      if (res.resultCode == 200) {
        this.form = res.data
        console.log('备注信息', this.form)
        if (this.form.companyCode) {
          // 如果有关联企业编号
          this.companyCode = this.form.companyCode
          if (this.form.positionId) {
            // 如果有职位id
            this.positionId = this.form.positionId
          }
        }
        this.currentErpriseName = this.form.corporateName
        //为空时设置默认值
        // if (this.form.contactsList.length == 0) {
        //   this.form.contactsList = [
        //     {
        //       contacts: '',
        //       phone: '',
        //       post: ''
        //     }
        //   ]
        // }
      }
    },
    // 删除图片
    deleteImg() {
      this.form.companyLogo = ''
    },
    //选择企业名称
    async enterpriseNameSelect(val) {
      const { value } = val
      this.currentErpriseName = value // 获取选中企业全称
      const { data: res } = await getCompanyNameList({ name: value })
      if (res.resultCode === 200) {
        const obj = res.data[0]
        this.selectEnterpriseDataHandle(obj) // 处理数据
        this.enterpriseNameList = []
        this.positionList = []
        this.getPositionList(value) // 调接口获取职位列表
      }
    },
    // 选中企业后处理数据
    selectEnterpriseDataHandle(obj) {
      // 替换企业相关数据
      const enterpriseValue = {
        companyCode: obj.companyCode, // 企业编号
        corporateName: obj.companyFullName, // 企业全称
        companyName: obj.companyName, // 企业简称
        companyProfile: obj.companyBriefIntroduction, // 企业简介
        industry: obj.industry, // 所在行业
        companyProvince: obj.companyProvince, // 企业所在省
        companyCity: obj.companyCity, // 企业所在城市
        companyDistrict: obj.companyDistrict, // 企业所在区
        companyLogo: obj.companyLogo // 企业图片
      }
      this.form = Object.assign(this.form, enterpriseValue)
      // 置空职位相关数据
      const positionValue = {
        recruitmentPosition: '',
        positionId: '',
        positionType: '',
        jobDescription: '',
        isAnnual: '',
        wages: '',
        wagess: '',
        requiredSkills: '',
        province: '',
        city: '',
        area: '',
        dutyStation: ''
      }
      this.form = Object.assign(this.form, positionValue)
      console.log(this.form, 'this.form')
    },
    //模糊查询企业名称
    async enterpriseNameQuerySearch(str, cb) {
      if (str != '') {
        const { data: res } = await getCompanyNameList({ name: str })
        if (res.resultCode === 200) {
          if (res.data.length) {
            res.data.forEach((item) => {
              this.enterpriseNameList.push({
                value: item.companyFullName,
                companyName: item.companyName,
                companyCode: item.companyCode
              })
            })
          }
          cb(this.enterpriseNameList)
        } else {
          this.$message.error('查询失败！')
        }
      }
    },
    // 根据企业名称获取职位数据列表
    async getPositionList(val) {
      const { data: res } = await selectPosition({ name: val })
      if (res.resultCode === 200) {
        if (res.data.length) {
          res.data.forEach((item) => {
            this.positionList.push({
              value: item.jobTitle,
              id: item.id
            })
          })
        }
      }
    },

    // 选择职位名称
    async positionSelect(val) {
      const { value, id } = val
      this.currentJobTitle = value
      const { data: res } = await getpositionListByid({ id })
      if (res.resultCode == 200) {
        this.selectPositionDataHandle(res.data)
      }
    },
    // 选中职位后处理数据
    selectPositionDataHandle(obj) {
      // 替换职位相关数据
      const positionValue = {
        recruitmentPosition: obj.recruitmentPosition,
        positionId: obj.id,
        positionType: obj.positionType,
        jobDescription: obj.jobDescription,
        isAnnual: obj.isAnnual,
        wages: obj.wages,
        wagess: obj.wagess,
        requiredSkills: obj.requiredSkills,
        province: obj.province,
        city: obj.city,
        area: obj.area,
        dutyStation: obj.dutyStation,
        salaryRange: obj.salaryRange
      }
      this.form = Object.assign(this.form, positionValue)
      // if (this.form.salaryRange) {
      //   const salaryArr = this.form.salaryRange.split('~')
      //   this.form.wages = salaryArr[0]
      //   this.form.wagess = salaryArr[1]
      // }
      console.log(this.form)
    },
    //模糊查询职位名称
    async positionListQuerySearch(str, cb) {
      if (str) {
        this.positionList = [] // 重置职位数据
        const { data: res } = await selectPosition({ name: this.currentErpriseName, jobTitle: str })
        if (res.resultCode === 200) {
          if (res.data.length) {
            res.data.forEach((item) => {
              this.positionList.push({
                value: item.jobTitle,
                id: item.id
              })
            })
          }
          cb(this.positionList)
        } else {
          this.$message.error('查询失败！')
        }
      } else {
        cb(this.positionList)
      }
    },
    // 企业、职位搜索 输入值变化时
    inputChanged() {
      this.enterpriseNameList = []
      this.positionList = []
    },
    // 选择项目经理
    async selectChange(value, item, index) {
      const { data: res } = await userListAll({ nameEnglish: value })
      const { mobile, email } = res.data[0]
      this.form.projectManagers[index].contactWay = mobile
      this.form.projectManagers[index].mail = email
    },
    //总部地址
    onContactSelected(data) {
      this.form.companyProvince = data.province.value
      this.form.companyCity = data.city.value
      this.form.companyDistrict = data.area.value
    },
    //工作地址
    onSelected(data) {
      this.form.province = data.province.value
      this.form.city = data.city.value
      this.form.area = data.area.value
    },
    // 总部地址
    searchArae(val) {
      if (this.time) {
        clearTimeout(this.time)
        this.time = null
      } else {
        this.time = null
      }
      this.time = setTimeout(() => {
        this.form.companyCountry = val.country
        this.form.companyProvince = val.province
        this.form.companyCity = val.city
      }, 500)
    },
    // 保存
    clickKeep() {
      this.form.companyCountry = '中国'
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.currentErpriseName !== this.form.corporateName) {
            // 数据库中不存在的企业全称
            this.form.companyCode = this.companyCode
          }
          if (this.currentJobTitle !== this.form.recruitmentPosition) {
            // 数据库中不存在的职位名称
            this.form.positionId = this.positionId
          }
          const { data: res } = await updateProject(this.form)
          if (res.resultCode == 200) {
            this.$message.success('修改成功')
            this.clickBack()
          } else {
            this.$message.error('修改失败')
          }
        } else {
          return this.$message.error('校验不通过~')
        }
      })
    },
    // 返回上级
    clickBack() {
      this.$router.go(-1)
    },
    // 导出JD
    clickDeriveJD() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const { data: res } = await updateProject(this.form)
          if (res.resultCode !== 200) {
            return this.$message.error('修改失败')
          } else {
            const { data: res } = await projectCenterReportDownLoad({
              id: this.form.id
            })
            if (res) {
              let blob = new Blob([res])
              let href = window.URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
              const a = document.createElement('a') //创建a标签
              a.style.display = 'none'
              a.href = href // 指定下载'链接
              a.download = `${this.form.corporateName}.doc` //指定下载文件名
              // a.download = `${this.form.corporateName}.pdf` //指定下载文件名
              // a.download = "test.png";
              //触发下载
              a.click()
              window.URL.revokeObjectURL(a.href) //释放URL对象
              if (document.body.contains(a)) {
                document.body.removeChild(a) //释放标签
              }
            }
          }
        } else {
          return false
        }
      })
    },
    // 获取项目经理
    async getProjectManagerList() {
      const { data: res } = await getProjectManager()
      if (res.resultCode == 200) {
        this.ProjectManagerList = res.data
      }
    },
    //添加主要联系人项
    // clickAddContact() {
    //   this.form.contactsList.push({
    //     contacts: '', //姓名
    //     post: '', //岗位
    //     phone: '' //联系方式
    //   })
    // },
    //删除主要联系人项
    // clickRemoveContact(item, index) {
    //   this.form.contactsList.splice(index, 1)
    // },
    // 添加
    clickAddProjectManagers() {
      this.form.projectManagers.push({
        contactWay: '', // 联系方式
        mail: '', // 邮箱
        projectManager: '' // 项目经理
        // targetEnterprise: '' // 目标企业
      })
    },
    // 删除
    clickRemoveProjectManagers(item, index) {
      this.form.projectManagers.splice(index, 1)
    }
  },
  created() {
    this.search()
    this.getProjectManagerList()
  },
  mounted() {}
}
</script>
<style scoped lang="less">
.add_project {
  .form_box {
    .flex_textarea {
      width: 80%;
    }

    ::v-deep .el-form-item {
      margin-bottom: 16px;
    }

    ::v-deep .distpicker-address-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    ::v-deep .distpicker-address-wrapper label {
      width: 32%;
    }

    ::v-deep .distpicker-address-wrapper label select {
      width: 100%;
      height: 32px;
      font-size: 14px;
      padding: 0 5px;
      border: 1px solid #dcdfe6;
      // 17757a
    }

    .corporate_information {
      display: flex;
      width: 100%;
      background-color: #fff;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 20px 0 20px 20px;
      margin-bottom: 20px;

      .logo {
        width: 100px;
        height: 100px;
        margin-right: 18px;

        .imgStyle {
          text-align: center;

          /deep/ .el-button {
            padding: 5px 10px;
            border-color: #17757a;
            color: #17757a;
          }
        }

        img {
          border-radius: 4px;
          width: 100%;
          height: 100%;
        }
      }

      .details {
        flex: 1;

        .name_industry,
        .address_contact {
          width: 70%;
          display: flex;
          justify-content: space-between;

          .flex_item {
            flex: 1;
          }

          ::v-deep .el-input__inner {
            width: 354px;
            height: 32px;
          }
        }

        .address_contact {
          margin-bottom: 10px;

          .distpicker_one {
            width: 354px;
          }

          /deep/ .middle-select,
          .middle-input {
            width: 110px !important;
            margin-right: 12px;
          }

          /deep/ .el-input__inner {
            height: 32px;
            line-height: 32px;
          }

          .contact {
            display: flex;
          }
        }

        .company_profile {
          width: 70%;

          /deep/.el-textarea {
            width: 100%;
          }
        }
      }
    }

    .post_details {
      background-color: #fff;
      border-radius: 4px;

      .post_details_heading {
        width: 100%;
        height: 43px;
        display: flex;
        align-items: center;
        padding-left: 21px;

        .line {
          width: 4px;
          height: 18px;
          border-radius: 4px;
          background-color: #17757a;
          margin-right: 8px;
        }

        .text {
          font-size: 16px;
          font-weight: 600;
          color: #17757a;
        }
      }

      // <!-- 招聘职位  薪资范围 -->
      .post_pay {
        width: 60%;
        display: flex;
        justify-content: space-between;
        padding-left: 124px;

        .post {
          /deep/.el-input__inner {
            width: 298px;
            height: 32px;
          }
        }

        .pay {
          /deep/.el-form-item__content {
            display: flex;
          }

          .wages {
            width: 95px;

            /deep/.el-input__inner {
              height: 32px;
              line-height: 32px;
              border-bottom-left-radius: 0;
              border-top-left-radius: 0;
              width: 95px;
            }
          }

          .wagess {
            width: 129px;

            /deep/.el-input__inner {
              height: 32px;
              line-height: 32px;
              width: 129px;
            }
          }

          .is_annual {
            width: 55px;
            height: 32px;

            /deep/.el-input__inner {
              padding: 0 0 0 6px;
              font-size: 12px;
              height: 32px;
              line-height: 32px;
              border-right: none;
              border-top-right-radius: 0px;
              border-bottom-right-radius: 0px;
            }

            /deep/.el-icon-arrow-up:before {
              content: '\e78f';
            }

            /deep/.el-input__icon {
              width: 14px;
            }
          }
        }
      }

      // <!-- 职位类型  工作地点 -->
      .positionType_place {
        width: 967px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        padding-left: 124px;

        .positionType {
          /deep/.el-input__inner {
            width: 298px;
            height: 32px;
          }
        }

        .place {
          display: flex;
          align-items: center;

          .distpicker {
            margin-right: 10px;
          }

          ::v-deep .el-form-item .el-form-item__content {
            display: flex;
            flex-flow: row nowrap;
          }

          ::v-deep .distpicker-address-wrapper select {
            min-width: 100px;
            height: 32px;
            font-size: 14px;
            padding: 0 5px;
          }

          ::v-deep .el-input__inner {
            width: 300px;
            height: 32px;
            box-sizing: border-box;
          }
        }
      }

      //  <!-- 汇报对象 -->
      .report_object {
        width: 967px;
        display: flex;
        justify-content: space-between;
        padding-left: 124px;

        .reportingObject {
          /deep/.el-input__inner {
            width: 295px;
            height: 32px;
            box-sizing: border-box;
          }
        }
      }

      .jobDescription {
        padding-left: 20px;

        .jobDescription_form_item {
          /deep/.el-form-item__content {
            margin-left: 0 !important;
          }
        }

        .jobDescription_title {
          margin-bottom: 8px;
        }
      }

      .requiredSkills {
        margin-top: 31px;
        padding-left: 20px;

        .requiredSkills_form_item {
          /deep/.el-form-item__content {
            margin-left: 0 !important;
          }
        }

        .requiredSkills_title {
          margin-bottom: 8px;
        }
      }

      .coreRequirements {
        margin-top: 31px;
        padding-left: 20px;

        .coreRequirements_form_item {
          /deep/.el-form-item__content {
            margin-left: 0 !important;
          }
        }

        .coreRequirements_title {
          margin-bottom: 8px;
        }
      }

      .projectManagers {
        .projectManagers_item {
          display: flex;
          align-items: center;
          // justify-content: space-between;
          width: 80%;
          height: 32px;
          margin-bottom: 25px;

          /deep/.el-form-item {
            margin-bottom: 0;
          }

          .projectManager {
            margin-right: 15px;

            /deep/.el-input__inner {
              height: 32px;
              width: 207px;
            }
          }

          .contactWay {
            /deep/.el-input__inner {
              height: 32px;
              width: 219px;
            }
          }

          .mail {
            margin-right: 15px;

            /deep/.el-input__inner {
              height: 32px;
              width: 219px;
            }
          }

          .targetEnterprise {
            margin-right: 15px;

            /deep/.el-input__inner {
              height: 32px;
              width: 219px;
            }
          }
        }
      }

      .marketFeedback {
        margin-top: 31px;
        padding-left: 20px;

        .marketFeedback_form_item {
          /deep/.el-form-item__content {
            margin-left: 0 !important;
          }
        }

        .marketFeedback_title {
          margin-bottom: 8px;
        }
      }

      .startTime_endTime {
        display: flex;

        .startTime {
          margin-right: 51px;
        }

        .endTime {
          margin-right: 51px;
        }
      }
    }
  }

  .options {
    display: flex;
    justify-content: center;
    background-color: #fff;
    padding-top: 23px;
    padding-bottom: 27px;

    .keep {
      width: 126px;
      height: 32px;
      border-radius: 4px;
      font-size: 14px;
      color: #fff;
      background-color: #17757a;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .back {
      width: 126px;
      height: 32px;
      border-radius: 4px;
      font-size: 14px;
      color: #17757a;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #17757a;
      cursor: pointer;
      margin: 0 21px;
    }

    .deriveJD {
      width: 126px;
      height: 32px;
      border-radius: 4px;
      font-size: 14px;
      color: #fff;
      background-color: #2a70b0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}

.contacts {
  .contact_list {
    display: flex;
    align-items: center;

    .contact_list_item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}

/* 添加、删除item项 */
.add {
  color: #17757a;
  // margin-right: 15px;
  cursor: pointer;

  .add_icon {
    font-size: 17px;
    margin-right: 8px;
  }
}

.remove {
  color: #f45454;
  cursor: pointer;

  .remove_icon {
    font-size: 17px;
    margin-right: 8px;
    color: #f45454;
  }
}

.contact_list_item ::v-deep .el-input__inner {
  height: 32px;
  min-width: 100px;
}
</style>
